import {Injectable, OnDestroy} from '@angular/core';
import {environment} from '../../environments/environment';
import {ClientEVent, Service, User} from '../../models/business-objects';
import {HttpClient} from '@angular/common/http';
import {AuthService} from './auth.service';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService implements OnDestroy{
  UrlAPI: string = environment.apiURL;
  public currentUser: User;
  subscriptions = [];
  constructor(private http: HttpClient, private authService: AuthService) {
    this.subscriptions.push(authService.currentUser.subscribe( user => this.currentUser = user));
  }

  getEvents(): Promise<ClientEVent[]> {
    console.log('getting events for :');
    console.log(this.currentUser);
    const formatoFecha = 'yyyy/MM/dd';
    const idpersonal = this.currentUser.id;
    return firstValueFrom(this.http.post<any>(this.UrlAPI + environment.URL_RESERVAS_DE_EVENTO, { idpersonal,formatoFecha}));
  }

  ngOnDestroy(): void {
  }
}
